import { render, staticRenderFns } from "./SasvList.vue?vue&type=template&id=6c75ef31"
import script from "./SasvList.vue?vue&type=script&lang=js"
export * from "./SasvList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports